<!--
 * @Description: 
 * @Author: Lizhiliang
 * @Date: 2022-12-16 14:47:01
 * @LastEditTime: 2024-01-05 10:47:01
 * @LastEditors: lizhiliang
 * @Usage: 
-->
<template>
    <div class="evn-domains">
      <template v-if="list.length > 0">
        <el-tag v-for="(item, index) in list" class="x-overflow-hidden" type="info" :key="index" size="mini">{{item.envs.map(env=>$opt.switchStr(env, $opt.env)).join(',')}}:&nbsp;{{item.domain}}</el-tag>
      </template>
      <span v-else>--</span>
    </div>
</template>

<script>
    export default {
      props: {
        list: {
          type: Array,
          default: () => {
            return [];
          }
        },
      },
    };
</script>

<style lang="scss" scoped>
    .evn-domains {
        display: flex;
        flex-direction: column;

        .el-tag--mini {
            height: auto;
            padding: 2px 5px;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>